module.exports = __webpack_public_path__ + "static/media/index_18.84b181da.jpg";